"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListenForAbFlagChanges = void 0;
const react_1 = require("react");
const loadVwoEvent = () => {
    window.VWO = window.VWO || [];
    window.dataLayer = window.dataLayer || [];
    window.VWO.push([
        'onVariationApplied',
        (data) => {
            if (!data) {
                return;
            }
            window.dispatchEvent(new Event('abFlagChanged'));
        },
    ]);
};
const getTestName = (flagName) => {
    var _a;
    if (typeof window === 'undefined')
        return null;
    const flag = (_a = window === null || window === void 0 ? void 0 : window.abTesting) === null || _a === void 0 ? void 0 : _a.tests[flagName];
    if (flag) {
        return flag;
    }
    return null;
};
function useListenForAbFlagChanges(name) {
    const [abFlag, setFlag] = (0, react_1.useState)(getTestName(name));
    (0, react_1.useEffect)(() => {
        loadVwoEvent();
    }, []);
    (0, react_1.useEffect)(() => {
        const handleCustomEvent = () => {
            setFlag(getTestName(name));
        };
        window.addEventListener('abFlagChanged', handleCustomEvent);
        return () => window.removeEventListener('abFlagChanged', handleCustomEvent);
    }, [name]);
    return abFlag;
}
exports.useListenForAbFlagChanges = useListenForAbFlagChanges;
